// action
import {
    GET_ROLE_MODULE_MAPPING_DETAIL,
    GET_ROLE_MODULE_MAPPING_DETAIL_FAIL,
    GET_ROLE_MODULE_MAPPING_DETAIL_SUCCESS,
    GET_ROLE_MODULE_MAPPING_DETAIL_RESET
} from '../action/getRoleModuleMappingDetailAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ROLE_MODULE_MAPPING_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_ROLE_MODULE_MAPPING_DETAIL_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_ROLE_MODULE_MAPPING_DETAIL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_ROLE_MODULE_MAPPING_DETAIL_RESET:
            return initialState
        default:
            return state
    }
}